/**
 * @file i18n/index.js — Configuration et initialisation de l'internationalisation (i18n)
 * de l'application Ringo via i18next.
 *
 * Utilise le plugin react-i18next pour l'intégration React, et
 * i18next-browser-languagedetector pour détecter automatiquement la langue
 * du navigateur ou celle enregistrée dans localStorage.
 *
 * Langues supportées : anglais (en) et français (fr).
 * La clé localStorage utilisée est « ringo-lang ».
 * Le namespace par défaut est « translation ».
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from '@texts/en.json';
import fr from '@texts/fr.json';

i18n
  /* Plugin de détection automatique de la langue (localStorage, puis navigateur) */
  .use(LanguageDetector)
  /* Plugin d'intégration React (fournit le hook useTranslation, le composant Trans, etc.) */
  .use(initReactI18next)
  /* Initialisation avec les options de configuration */
  .init({
    /* Ressources de traduction chargées statiquement (pas de backend HTTP) */
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    /* Langue de repli si la détection échoue ou si une clé est absente */
    fallbackLng: 'en',
    /* Namespace par défaut utilisé par useTranslation() sans argument */
    defaultNS: 'translation',
    /* Pas d'échappement HTML : React gère déjà l'échappement des valeurs */
    interpolation: {
      escapeValue: false,
    },
    /* Options du détecteur de langue */
    detection: {
      /* Ordre de détection : d'abord localStorage, puis la langue du navigateur */
      order: ['localStorage', 'navigator'],
      /* Active la mise en cache de la langue choisie dans localStorage */
      cacheUserLanguage: true,
      /* Clé localStorage utilisée pour stocker la préférence linguistique */
      lookupLocalStorage: 'ringo-lang',
    },
  });

export default i18n;
